// extracted by mini-css-extract-plugin
export var externalLink = "_g6-0";
export var internalLinkLabel = "_g6-1";